import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../utils/queryParams.js";

export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";

export const FETCH_PRIMARY_REVENUE_CATEGORIES = "saga/FETCH_PRIMARY_REVENUE_CATEGORIES";
export const FETCH_PRIMARY_REVENUE_CATEGORIES_SUCCESS = "saga/FETCH_PRIMARY_REVENUE_CATEGORIES_SUCCESS";
export const FETCH_PRIMARY_REVENUE_CATEGORIES_FAILURE = "saga/FETCH_PRIMARY_REVENUE_CATEGORIES_FAILURE";

export const FETCH_PRICING_OPTION = "saga/FETCH_PRICING_OPTION";
export const FETCH_PRICING_OPTION_SUCCESS = "saga/FETCH_PRICING_OPTION_SUCCESS";
export const FETCH_PRICING_OPTION_FAILURE = "saga/FETCH_PRICING_OPTION_FAILURE";

export const UPDATE_PRICING_OPTION = "saga/UPDATE_PRICING_OPTION";
export const UPDATE_PRICING_OPTION_SUCCESS = "saga/UPDATE_PRICING_OPTION_SUCCESS";
export const UPDATE_PRICING_OPTION_FAILURE = "saga/UPDATE_PRICING_OPTION_FAILURE";

export const MASS_UPDATE_CATEGORY = "saga/MASS_UPDATE_CATEGORY";
export const MASS_UPDATE_CATEGORY_SUCCESS = "saga/MASS_UPDATE_CATEGORY_SUCCESS";
export const MASS_UPDATE_CATEGORY_FAILURE = "saga/MASS_UPDATE_CATEGORY_FAILURE";

export const MASS_UPDATE_TAGS = "saga/MASS_UPDATE_TAGS";
export const MASS_UPDATE_TAGS_SUCCESS = "saga/MASS_UPDATE_TAGS_SUCCESS";
export const MASS_UPDATE_TAGS_FAILURE = "saga/MASS_UPDATE_TAGS_FAILURE";

export const CREATE_NEW_CATEGORY = "saga/CREATE_NEW_CATEGORY";
export const CREATE_NEW_CATEGORY_SUCCESS = "saga/CREATE_NEW_CATEGORY_SUCCESS";
export const CREATE_NEW_CATEGORY_FAILURE = "saga/CREATE_NEW_CATEGORY_FAILURE";
export const DELETE_PRIMARY_CATEGORY = "saga/DELETE_PRIMARY_CATEGORY";
export const DELETE_PRIMARY_CATEGORY_SUCCESS = "saga/DELETE_PRIMARY_CATEGORY_SUCCESS";
export const DELETE_PRIMARY_CATEGORY_FAILURE = "saga/DELETE_PRIMARY_CATEGORY_FAILURE";

export const SEARCH_PRICING_OPTIONS = "saga/SEARCH_PRICING_OPTIONS";
export const SEARCH_PRICING_OPTIONS_SUCCESS = "saga/SEARCH_PRICING_OPTIONS_SUCCESS";
export const SEARCH_PRICING_OPTIONS_FAILURE = "saga/SEARCH_PRICING_OPTIONS_FAILURE";

export const SET_SEARCH_PARAMS = "saga/SET_SEARCH_PARAMS";
export const SET_OPTION_LOADING = "saga/SET_OPTION_LOADING";
export const CREATE_SECONDARY_CATEGORY = "saga/CREATE_SECONDARY_CATEGORY";
export const CREATE_SECONDARY_CATEGORY_SUCCESS = "saga/CREATE_SECONDARY_CATEGORY_SUCCESS";
export const CREATE_SECONDARY_CATEGORY_FAILURE = "saga/CREATE_SECONDARY_CATEGORY_FAILURE";
export const DELETE_SECONDARY_CATEGORY = "saga/DELETE_SECONDARY_CATEGORY";
export const DELETE_SECONDARY_CATEGORY_SUCCESS = "saga/DELETE_SECONDARY_CATEGORY_SUCCESS";
export const DELETE_SECONDARY_CATEGORY_FAILURE = "saga/DELETE_SECONDARY_CATEGORY_FAILURE";

export const CLOSE_SEARCH = "saga/CLOSE_SEARCH";
export const TOGGLE_SHOW_EMPTY = "sagas/TOGGLE_SHOW_EMPTY";
export const TOGGLE_SHOW_EMPTY_SUCCESS = "sagas/TOGGLE_SHOW_EMPTY_SUCCESS";
export const TOGGLE_SHOW_INACTIVE = "sagas/TOGGLE_SHOW_INACTIVE";
export const TOGGLE_SHOW_INACTIVE_SUCCESS = "sagas/TOGGLE_SHOW_INACTIVE_SUCCESS";

export const FETCH_DATA_ERROR = "sagas/FETCH_DATA_ERROR";
export const SET_MODAL_LOADING = "sagas/SET_MODAL_LOADING";
export const CLEAR_ERRORS = "sagas/CLEAR_ERRORS";
export const CLEAR_ERRORS_SUCCESS = "sagas/CLEAR_ERRORS_SUCCESS";

export const GET_CATEGORY_BY_TAG = "sagas/GET_CATEGORY_BY_TAG";

export const SET_TAGS_LOADING = "sagas/SET_TAGS_LOADING";

// const axios = defaultNetworkService()

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  getPricingOption: createAction(FETCH_PRICING_OPTION),
  updatePricingOption: createAction(UPDATE_PRICING_OPTION),
  massUpdateCategory: createAction(MASS_UPDATE_CATEGORY),
  massUpdateTags: createAction(MASS_UPDATE_TAGS),
  createNewCategory: createAction(CREATE_NEW_CATEGORY),
  searchCategories: createAction(SEARCH_PRICING_OPTIONS),
  createSecondaryCategory: createAction(CREATE_SECONDARY_CATEGORY),
  deleteSecondaryCategory: createAction(DELETE_SECONDARY_CATEGORY),
  deletePrimaryCategory: createAction(DELETE_PRIMARY_CATEGORY),
  closeSearch: createAction(CLOSE_SEARCH),
  toggleShowEmpty: createAction(TOGGLE_SHOW_EMPTY),
  toggleShowInactive: createAction(TOGGLE_SHOW_INACTIVE),
  clearErrors: createAction(CLEAR_ERRORS),
  getCategoriesByTag: createAction(GET_CATEGORY_BY_TAG)
};
export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUser);
  yield takeLatest(FETCH_PRICING_OPTION, getPricingOption);
  yield takeLatest(UPDATE_PRICING_OPTION, updatePricingOption);
  yield takeLatest(MASS_UPDATE_CATEGORY, massUpdateCategory);
  yield takeLatest(MASS_UPDATE_TAGS, massUpdateTags);
  yield takeLatest(CREATE_NEW_CATEGORY, createNewCategory);
  yield takeLatest(SEARCH_PRICING_OPTIONS, searchCategories);
  yield takeLatest(CREATE_SECONDARY_CATEGORY, createSecondaryCategory);
  yield takeLatest(DELETE_SECONDARY_CATEGORY, deleteSecondaryCategory);
  yield takeLatest(DELETE_PRIMARY_CATEGORY, deletePrimaryCategory);
  yield takeLatest(CLOSE_SEARCH, closeSearch);
  yield takeLatest(TOGGLE_SHOW_EMPTY, toggleShowEmpty);
  yield takeLatest(TOGGLE_SHOW_INACTIVE, toggleShowInactive);
  yield takeLatest(CLEAR_ERRORS, clearErrors);
  yield takeLatest(GET_CATEGORY_BY_TAG, getCategoryByTag);
}

export function* clearErrors() {
  yield put({ type: CLEAR_ERRORS_SUCCESS, payload: true });
}

export function getTags(showTags) {
  if (showTags !== undefined && showTags.payload !== "" && showTags.payload.indexOf("not") !== 0) {
    return `&filter[tags][${showTags.payload}]=true`;
  } else if (showTags !== undefined && showTags.payload !== "" && showTags.payload.indexOf("not") == 0) {
    let tag = showTags.payload.split("not_");
    return `&filter[tags][${tag[1]}]=false`;
  } else {
    return "";
  }
}

export function* fetchCurrentUser(data) {
  // Get user data first. Once we confirm we have user data pass to other sagas and call them.
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });

  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const showEmpty = yield select(state => state.pricingOptionsMapping.showEmpty);
  const showInactive = yield select(state => state.pricingOptionsMapping.showInactive);

  const allSagas = [getPrimaryRevenueCategories(id, objectId, showEmpty, showInactive)];
  try {
    // effects will get executed in parallel
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    //
  }
}

export function* getCategoryByTag(data) {
  yield put({ type: SET_TAGS_LOADING, payload: true });

  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const showEmpty = yield select(state => state.pricingOptionsMapping.showEmpty);
  const showInactive = yield select(state => state.pricingOptionsMapping.showInactive);

  const allSagas = [getPrimaryRevenueCategories(id, objectId, showEmpty, showInactive, data)];
  try {
    // effects will get executed in parallel
    yield all(allSagas);
    yield put({ type: SET_TAGS_LOADING, payload: false });
  } catch (error) {
    //
  }
}

export function* getPrimaryRevenueCategories(id, objectId, showEmpty, showInactive, showTags) {
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "/settings/primary_revenue_categories" +
        "?organization_id=" +
        id +
        "&object_id=" +
        objectId +
        `&filter[show_empty]=${showEmpty}` +
        `&filter[show_inactive]=${showInactive}` +
        `${getTags(showTags)}`
    );
    yield put({ type: FETCH_PRIMARY_REVENUE_CATEGORIES_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_PRIMARY_REVENUE_CATEGORIES_FAILURE, error });
  }
}

export function* searchCategories(data) {
  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const activeSearchQuery = yield select(state => state.pricingOptionsMapping.searchParams.query);
  let searchQuery = null;
  const searchIsNew = data.payload.toString() !== activeSearchQuery.toString();
  if (searchIsNew) {
    searchQuery = data.payload;
  } else {
    searchQuery = activeSearchQuery;
  }
  yield put({ type: SET_OPTION_LOADING, payload: { loading: true, id: "search-row" } });
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion + "settings/pricing_options" + "?organization_id=" + id + "&object_id=" + objectId + "&filter[search]=" + searchQuery.toString()
    );
    yield put({ type: SEARCH_PRICING_OPTIONS_SUCCESS, payload: { data: response.data, id: "search-row" } });
    yield put({ type: SET_OPTION_LOADING, payload: { loading: false, id: null } });
    yield put({ type: SET_SEARCH_PARAMS, payload: { query: data.payload.toString(), active: true } });
  } catch (error) {
    console.error(error);
    yield put({ type: SEARCH_PRICING_OPTIONS_FAILURE, error });
  }
}

export function* getPricingOption(data) {
  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  yield put({ type: SET_OPTION_LOADING, payload: { loading: true, id: data.payload.rowId } });
  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion + "settings/pricing_options" + "?organization_id=" + id + "&object_id=" + objectId + "&revenue_category_id=" + data.payload.id
    );
    yield put({ type: FETCH_PRICING_OPTION_SUCCESS, payload: { data: response.data, id: data.payload.rowId } });
    yield put({ type: SET_OPTION_LOADING, payload: { loading: false, id: null } });
  } catch (error) {
    console.log("pricing error:", error);
    yield put({ type: FETCH_PRICING_OPTION_FAILURE, error });
    yield put({ type: SET_OPTION_LOADING, payload: { loading: false, id: null } });
  }
}

export function* updatePricingOption(data) {
  const sagaData = {
    payload: {
      rowId: data.payload.row,
      id: data.payload.cat
    }
  };
  const allSagas = [];
  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const searchActive = yield select(state => state.pricingOptionsMapping.searchParams.active);
  const searchQuery = yield select(state => state.pricingOptionsMapping.searchParams.query);

  if (searchActive) {
    allSagas.push(searchCategories({ payload: searchQuery }));
  } else {
    allSagas.push(getPricingOption(sagaData));
  }
  try {
    yield call(
      axios.put,
      queryParams.apiVersion +
        "/settings/pricing_options/" +
        data.payload.id +
        "?organization_id=" +
        id +
        "&object_id=" +
        objectId +
        "&pricing_option[revenue_category_id]=" +
        data.payload.cat.toString() +
        `&pricing_option[${data.payload.tag}]=${data.payload.active}`
    );
    yield all(allSagas);
  } catch (error) {
    console.log("pricing error:", error);
    yield put({ type: UPDATE_PRICING_OPTION_FAILURE, error });
  }
}

export function* massUpdateCategory(data) {
  const sagaData = {
    payload: {
      rowId: data.payload.row,
      id: data.payload.catId
    }
  };
  const changeId = data.payload.changeId;
  const values = data.payload.values;

  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const searchActive = yield select(state => state.pricingOptionsMapping.searchParams.active);
  const searchQuery = yield select(state => state.pricingOptionsMapping.searchParams.query);
  const showEmpty = yield select(state => state.pricingOptionsMapping.showEmpty);
  const showInactive = yield select(state => state.pricingOptionsMapping.showInactive);

  const allSagas = [getPrimaryRevenueCategories(id, objectId, showEmpty, showInactive)];
  if (searchActive) {
    allSagas.push(searchCategories({ payload: searchQuery }));
  } else {
    allSagas.push(getPricingOption(sagaData));
  }
  try {
    yield call(
      axios.put,
      queryParams.apiVersion +
        "settings/pricing_options/mass_update" +
        "?organization_id=" +
        id +
        "&object_id=" +
        objectId +
        "&pricing_option[revenue_category_id]=" +
        changeId.toString() +
        `&id=${values}`
    );
    yield put({ type: SET_LOADING, payload: true });
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.log("pricing error:", error);
    yield put({ type: MASS_UPDATE_CATEGORY_FAILURE, error });
  }
}

export function* massUpdateTags(data) {
  let tags = "";
  let nonTags = "";

  data.payload.tags.map(item => {
    tags = tags + `&pricing_option[${item.value}]=true`;
  });

  data.payload.nonTags.map(item => {
    nonTags = nonTags + `&pricing_option[${item.value}]=false`;
  });

  const sagaData = {
    payload: {
      rowId: data.payload.row,
      id: data.payload.catId
    }
  };
  const values = data.payload.values;

  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const searchActive = yield select(state => state.pricingOptionsMapping.searchParams.active);
  const searchQuery = yield select(state => state.pricingOptionsMapping.searchParams.query);
  const showEmpty = yield select(state => state.pricingOptionsMapping.showEmpty);
  const showInactive = yield select(state => state.pricingOptionsMapping.showInactive);

  const allSagas = [getPrimaryRevenueCategories(id, objectId, showEmpty, showInactive)];
  if (searchActive) {
    allSagas.push(searchCategories({ payload: searchQuery }));
  } else {
    allSagas.push(getPricingOption(sagaData));
  }
  try {
    yield call(
      axios.put,
      queryParams.apiVersion + "settings/pricing_options/mass_update" + "?organization_id=" + id + "&object_id=" + objectId + `&id=${values}` + tags + nonTags
    );
    yield put({ type: SET_LOADING, payload: true });
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
    yield put({ type: MASS_UPDATE_TAGS_FAILURE, error });
  }
}

export function* createNewCategory(data) {
  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const showEmpty = yield select(state => state.pricingOptionsMapping.showEmpty);
  const showInactive = yield select(state => state.pricingOptionsMapping.showInactive);

  const allSagas = [getPrimaryRevenueCategories(id, objectId, showEmpty, showInactive)];
  try {
    yield call(axios.post, queryParams.apiVersion + "settings/primary_revenue_categories" + "?organization_id=" + id + "&object_id=" + objectId, {
      primary_revenue_category: {
        name: data.payload.name,
        category_type: data.payload.type
      }
    });
    yield put({ type: SET_LOADING, payload: true });
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    const resError = error.response.data.errors.identifier[0];
    yield put({ type: FETCH_DATA_ERROR, payload: resError });
    yield put({ type: SET_MODAL_LOADING, payload: false });
    yield put({ type: CREATE_NEW_CATEGORY_FAILURE, error });
  }
}

export function* createSecondaryCategory(data) {
  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const showEmpty = yield select(state => state.pricingOptionsMapping.showEmpty);
  const showInactive = yield select(state => state.pricingOptionsMapping.showInactive);

  const allSagas = [getPrimaryRevenueCategories(id, objectId, showEmpty, showInactive)];
  try {
    yield call(axios.post, queryParams.apiVersion + "settings/revenue_categories" + "?organization_id=" + id + "&object_id=" + objectId, {
      revenue_category: {
        name: data.payload.name,
        primary_revenue_category_id: data.payload.id.toString(),
        category_type: data.payload.catType,
        payment_type: data.payload.paymentType,
        revenue_type: data.payload.revenueType
      }
    });
    yield put({ type: SET_LOADING, payload: true });
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
    yield put({ type: CREATE_SECONDARY_CATEGORY_FAILURE, error });
  }
}

export function* deletePrimaryCategory(data) {
  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const showEmpty = yield select(state => state.pricingOptionsMapping.showEmpty);
  const showInactive = yield select(state => state.pricingOptionsMapping.showInactive);
  yield put({ type: SET_MODAL_LOADING, payload: true });

  const allSagas = [getPrimaryRevenueCategories(id, objectId, showEmpty, showInactive)];
  try {
    yield call(
      axios.delete,
      queryParams.apiVersion + "settings/primary_revenue_categories/" + data.payload + "?organization_id=" + id + "&object_id=" + objectId
    );
    yield put({ type: SET_LOADING, payload: true });
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
    yield put({ type: SET_MODAL_LOADING, payload: false });
  } catch (error) {
    const resError = error.response.data.errors[0];
    yield put({ type: DELETE_PRIMARY_CATEGORY_FAILURE, resError });
    yield put({ type: FETCH_DATA_ERROR, payload: resError });
    yield put({ type: SET_MODAL_LOADING, payload: false });
    console.log("resError", resError);
  }
}

export function* deleteSecondaryCategory(data) {
  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const showEmpty = yield select(state => state.pricingOptionsMapping.showEmpty);
  const showInactive = yield select(state => state.pricingOptionsMapping.showInactive);

  const allSagas = [getPrimaryRevenueCategories(id, objectId, showEmpty, showInactive)];
  try {
    yield call(axios.delete, queryParams.apiVersion + "settings/revenue_categories/" + data.payload + "?organization_id=" + id + "&object_id=" + objectId);
    yield put({ type: SET_LOADING, payload: true });
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
    yield put({ type: DELETE_SECONDARY_CATEGORY_FAILURE, error });
  }
}

export function* toggleShowEmpty(data) {
  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const showInactive = yield select(state => state.pricingOptionsMapping.showInactive);
  const allSagas = [getPrimaryRevenueCategories(id, objectId, data.payload, showInactive)];

  yield put({ type: TOGGLE_SHOW_EMPTY_SUCCESS, payload: data.payload });

  yield put({ type: SET_LOADING, payload: true });
  yield all(allSagas);
  yield put({ type: SET_LOADING, payload: false });
}

export function* toggleShowInactive(data) {
  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const showEmpty = yield select(state => state.pricingOptionsMapping.showEmpty);
  const allSagas = [getPrimaryRevenueCategories(id, objectId, showEmpty, data.payload)];

  yield put({ type: TOGGLE_SHOW_INACTIVE_SUCCESS, payload: data.payload });

  yield put({ type: SET_LOADING, payload: true });
  yield all(allSagas);
  yield put({ type: SET_LOADING, payload: false });
}

export function* closeSearch() {
  const id = yield select(state => state.pricingOptionsMapping.currentUser.organizationId);
  const objectId = yield select(state => state.pricingOptionsMapping.currentUser.objectId);
  const showEmpty = yield select(state => state.pricingOptionsMapping.showEmpty);
  const showInactive = yield select(state => state.pricingOptionsMapping.showInactive);
  yield put({ type: SET_SEARCH_PARAMS, payload: { query: "", active: false } });

  yield put({ type: SET_LOADING, payload: true });
  const allSagas = [getPrimaryRevenueCategories(id, objectId, showEmpty, showInactive)];

  yield all(allSagas);
  yield put({ type: SET_LOADING, payload: false });
}
